import * as _ from 'lodash';
import { TimeString } from '../misc/TimeString';
import * as utility from '../misc/utility';
import { AuditData } from './Audit';
import { AttachmentInfo } from './Attachment';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
*/

export const ceremonyStates = Object.freeze({
    none: 0,
    created: 1,
    reported: 2,
    rejected: 3,
    accepted: 4,
});

export class CeremonyInfo {
    /**
     * @param {any} src
     * @param {ResponseContext} ctx
     */
    constructor(src, ctx) {
        this.EventId = src.EventId;
        this.MissionId = src.MissionId;
        this.Designation = src.Designation;
        this.Location = src.Location;
        this.State = src.State;
        this.StateTimestamp = utility.parseDate(src.StateTimestamp);
        this.CeremonyDate = utility.parseDate(src.CeremonyDate);
        let ts = TimeString.parse(src.CeremonyTime);
        this.CeremonyTime = ts != null ? ts.str : src.CeremonyTime;
        
        this.Mission = ctx.getMission(this.MissionId);
    }

    /**
     * @param {any} src
     * @param {ResponseContext} ctx
     */
    static mapResponse(src, ctx) {
        return new CeremonyInfo(src, ctx);
    }
}

export class CeremonyDetails extends CeremonyInfo {
    /**
     * @param {any} src
     * @param {ResponseContext} ctx
     */
    constructor(src, ctx) {
        super(src, ctx);
        this.Attachments = _.map(src.Attachments, x => new AttachmentInfo(x));
        this.ClaimIds = src.ClaimIds;
        this.AuditEntries = _.map(src.AuditEntries, x => AuditData.create(x, ctx));
        this.Claims = _.map(src.ClaimIds, x => ctx.getClaim(x));
    }

    /**
     * @param {any} src
     * @param {ResponseContext} ctx
     */
    static mapResponse(src, ctx) {
        return new CeremonyDetails(src, ctx);
    }
}